import { useEffect } from 'react'

//lib
import { MDBContainer } from 'mdb-react-ui-kit'

//component
import Header from '../../components/header/header-main'
import TermsData from './component/terms.and.conditions'

export default function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <MDBContainer className="common-main-container" breakpoint="none">
      <Header />
      <TermsData />
    </MDBContainer>
  )
}
